import { InfiniteScrollSetup } from "../../components/infinite-scroll/infinite-scroll-setup";

export class BrandsInfiniteScrollSetup {
    public static init(root: HTMLElement): void {
        if (!(root instanceof HTMLElement)) return;
        if (!root.classList.contains("brand-cards-grid")) return;

        InfiniteScrollSetup.init(root, {
            listSelector: ".brand-cards-grid",
            itemSelector: ".brand-card",
            paginationSelector: ".pagination-nav",
            nextLinkSelector: 'a[aria-label="Next page"]',
            rootMargin: "260px 0px",
            hidePaginationOnMobile: true,
        });
    }
}
